module.exports = fox._r("images/about-total-placeholder.png", __webpack_public_path__ + "images/about-total-placeholder.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/about-total-placeholder.png
// module id = 1020
// module chunks = 4